import React from 'react'
import type { Props } from '../_utils/types'
import type {
  SplitViewCardContextAPI,
  SplitViewCardProps,
} from './SplitViewCard.types'

export const SplitViewCardContext =
  React.createContext<SplitViewCardContextAPI>({
    isOpen: false,
    show: () => {},
    hide: () => {},
    mainSectionRef: { current: null },
  })

export const SplitViewCardContextProvider = ({
  children,
  isInitiallyOpen = false,
}: React.PropsWithChildren<Props & SplitViewCardProps>) => {
  const [isOpen, setIsOpen] = React.useState(isInitiallyOpen)
  const mainSectionRef = React.useRef<HTMLDivElement>(null)

  const show = () => {
    setIsOpen(true)
  }

  const hide = () => {
    setIsOpen(false)

    if (mainSectionRef.current) {
      mainSectionRef.current.focus()
    }
  }

  return (
    <SplitViewCardContext.Provider
      value={{
        isOpen,
        show,
        hide,
        mainSectionRef,
      }}
    >
      {children}
    </SplitViewCardContext.Provider>
  )
}

export const useSplitViewCard = () => React.useContext(SplitViewCardContext)
